import { canSetEnrollmentGraduated, isEnrollmentStatusLocked, withEnrollmentStatusForUpdate, isEnrollmentGraduatedForbidden } from 'utils/enrollmentGraduatedAccess';
import useAuth from 'hooks/useAuth';
import React from 'react';

import { Box, Button, useToast, Select } from '@chakra-ui/react';
import xhr from 'xhr';

export default function UpdateCourse(props) {
  const {
    groupEnrollment,
    setGroupEnrollment,
    semesterEnrollment,
    setSemesterEnrollment,
    currentEnrollment,
    setCurrentEnrollment,
    id_est,
    dataAll,
    enrollments,
    semester,
    mutate,
  } = props;

  const [loading, setLoading] = React.useState(false);
  const [classGroups, setClassGroups] = React.useState([]);
  const toasts = useToast();
  const { user } = useAuth();
  const [statusEnrollment, setStatusEnrollment] = React.useState(currentEnrollment.status || 'registrado');
  const canSetGraduated = canSetEnrollmentGraduated(user);
  const statusLocked = isEnrollmentStatusLocked(user, currentEnrollment.status);
  React.useEffect(() => {
    setStatusEnrollment(currentEnrollment.status || 'registrado');
  }, [currentEnrollment.id, currentEnrollment.status]);
  React.useEffect(() => {
    const getGroups = async () => {
      try {
        const res = await xhr(
          `/class-groups?filters[course][id][$eq]=${currentEnrollment.course.id}&pagination[limit]=-1&populate=*`
        );

        setClassGroups(res.data.data);
      } catch (error) {}
    };
    getGroups();
  }, [currentEnrollment.id]);

  const updateState = async () => {
    try {
      if (!semesterEnrollment || !groupEnrollment) {
        return window.alert('Debes llenar todos los campos');
      }

      setLoading(true);

      const resUpdate = await xhr.put(`/course-enrollments/${currentEnrollment.id}`, {
        data: withEnrollmentStatusForUpdate({
          user,
          statusEnrollment,
          currentStatus: currentEnrollment.status,
          data: { semester: semesterEnrollment },
        }),
      });

      const classGroup = classGroups.find((el) => {
        return Number(el.id) === Number(groupEnrollment);
      });

      let studentGroup = {};
      if (classGroup && Number(groupEnrollment) !== currentEnrollment.class_group?.id) {
        if (currentEnrollment.student_group) {
          await xhr.delete(`/student-groups/${currentEnrollment.student_group.id}`);
        }

        const studentGroupResponse = await xhr.post('/student-groups', {
          data: {
            student: id_est,
            class_group: groupEnrollment,
          },
        });
        const resN = await xhr(`/student-groups/${studentGroupResponse.data.data.id}?populate=*`);

        studentGroup = resN.data.data;
        setGroupEnrollment(groupEnrollment);

        setCurrentEnrollment({
          ...currentEnrollment,
          class_group: studentGroup?.class_group,
          student_group: studentGroup,
        });
      }
      mutate(
        {
          ...dataAll,
          enrollments: enrollments.map((el) => {
            if (el.id === currentEnrollment.id) {
              return {
                ...el,
                ...resUpdate.data.data,
                class_group: studentGroup?.class_group,
                student_group: studentGroup,
              };
            }

            return el;
          }),
        },
        { revalidate: false }
      );

      setCurrentEnrollment((previous) => ({ ...previous, status: resUpdate.data.data.status || previous.status }));

      toasts({
        title: 'El enrollment se actualizó correctamente!',
        accent: 'bottom',
      });
    } catch (error) {
      console.error(error);
      if (isEnrollmentGraduatedForbidden(error)) {
        toasts({ title: 'Solo Supervisor Admin puede marcar como graduado', status: 'error' });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box>
        <Box>
          <Box fontWeight="bold" fontSize="20px">
            Modificar {currentEnrollment.course.name}
          </Box>
          <hr />
          <Select
            value={statusEnrollment}
            marginTop="20px"
            name="estado_enrollment"
            aria-label="Estado de la matrícula"
            isDisabled={statusLocked}
            onChange={(event) => setStatusEnrollment(event.target.value)}
          >
            <option value="registrado">Registrado</option>
            <option value="estudiando">Estudiando</option>
            <option value="promovido">Promovido</option>
            {(canSetGraduated || currentEnrollment.status === 'graduado') && (
              <option value="graduado">Graduado</option>
            )}
            <option value="retirado">Retirado</option>
            <option value="no_aprobado">No Aprobado</option>
          </Select>

          <Select
            value={semesterEnrollment}
            marginTop="20px"
            name="semester_enrollment"
            label="Semestre"
            color="black"
            onChange={(e) => setSemesterEnrollment(e.target.value)}
          >
            {semester.map((el) => (
              <option value={el.value}>{el.label}</option>
            ))}
          </Select>

          <Select
            value={groupEnrollment}
            marginTop="20px"
            name="group_enrollment"
            color="black"
            placeholder="Grupo"
            onChange={(e) => setGroupEnrollment(Number(e.target.value))}
            options={classGroups}
          >
            {classGroups.map((el) => (
              <option value={el.id}>{el.name}</option>
            ))}
          </Select>
        </Box>
        <br />
        <Button
          type="submit"
          colorScheme="#574feb"
          backgroundColor="#574feb"
          marginTop="15px"
          width="100%"
          isLoading={loading}
          onClick={updateState}
        >
          Actualizar
        </Button>
      </Box>
    </>
  );
}
